import { Component, input } from '@angular/core';
import { AuthUserDto } from '@artemis-software/wr-api';
import { CheckpointFormWrapper } from '@pages/checkpoint-detail-page/checkpoint-form';

@Component({
  selector: 'wr-checkpoint-detail-form',
  standalone: false,
  templateUrl: './checkpoint-detail-form.component.html',
  styleUrl: './checkpoint-detail-form.component.scss'
})
export class CheckpointDetailFormComponent {
  formWrapper = input.required<CheckpointFormWrapper>();
  currentTenantId = input.required<string | undefined>();

  protected readonly TenantTypeEnum = AuthUserDto.TenantTypeEnum;
}
